import { createSlice } from "@reduxjs/toolkit";
import { fetchServiceItems } from "../actions/serviceItemsAction";

const initialState = {
  data: [],
  isLoading: false,
  error: null,
};

const serviceItemsSlice = createSlice({
  name: "serviceItems",
  initialState,
  reducers: {
    clearServiceItems: (state) => {
      state.data = [];
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchServiceItems.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchServiceItems.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload.data;
        state.error = null;
      })
      .addCase(fetchServiceItems.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload?.message || "Failed to fetch service items";
      });
  },
});

export const { clearServiceItems } = serviceItemsSlice.actions;
export default serviceItemsSlice.reducer;
